import { IAppState } from '../../store';

export const selectReviewFormState = (state: IAppState) => state.reviewForm.state;
